<template>
  <div
    class='jumbotron jumbotron-fluid py-5'
    style='background: url("./banner3.jpg") right bottom; color: white;'
  >
    <div class='container'>
      <h1 class='h2'>
        Foundation GEOINT Standards (FGS) Data Product Specification (DPS)
      </h1>
      <small>GCES v7.0.3.4 Approved for Public Release by NGA/SFCAA: FGS-1-10062017</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheBanner'
};
</script>
<style lang="scss" scoped>
h1 {
  text-shadow: 1px 1px 0px #495057;
  font-style: italic;
}
h1 small {
  text-shadow: none;
}
.jumbotron {
  border-bottom: 2px solid #32a6ad;
  border-top: 2px solid #32a6ad;
}
@media only screen and (max-width: 800px){ 
  .py-5{
    padding-top: 0% !important;
    padding-bottom: 0% !important;
  }
}
</style>
